/* global RELEASE_VERSION */
/* global USE_RUM */
/* global RUM_APPLICATION_ID */
/* global RUM_CLIENT_TOKEN */
/* global DEPLOYMENT_ENVIRONMENT */
/* global DD_LOGS_HANDLER */
/* global DD_LOGS_LEVEL */
/* global USE_SENTRY */
/* global SENTRY_SAMPLE_RATE */
/* global SENTRY_DSN */

import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

// Sentry
import * as Sentry from '@sentry/react'

if (USE_RUM === true) {
  datadogRum.init({
    applicationId: RUM_APPLICATION_ID,
    clientToken: RUM_CLIENT_TOKEN,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    defaultPrivacyLevel: 'mask-user-input',
    actionNameAttribute: 'data-testid',
    service: 'appraiser-frontend',
    env: DEPLOYMENT_ENVIRONMENT,
    version: RELEASE_VERSION,
  })
}

datadogLogs.init({
  service: 'appraiser-frontend',
  env: DEPLOYMENT_ENVIRONMENT,
  version: RELEASE_VERSION,
  clientToken: RUM_CLIENT_TOKEN,
  forwardReports: [],
  forwardConsoleLogs: [],
  forwardErrorsToLogs: false,
  sessionSampleRate: 100,
  telemetrySampleRate: 100,
})

datadogLogs.logger.setHandler(DD_LOGS_HANDLER || 'console')
datadogLogs.logger.setLevel(DD_LOGS_LEVEL || 'error')

if (USE_SENTRY === 'true') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: DEPLOYMENT_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: SENTRY_SAMPLE_RATE || 0.0,
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
  })
}
